import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { Img } from '@/components/blocks/MaterialImage';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { Box, ButtonBase, Divider, Skeleton, Typography } from '@mui/material';
import { useDpFanStages } from '@/data/Content/DpFanStages';

export const DpFanAccountCard = () => {
	const { isLoadingUserInterests, isLoadingPersonInfo, onSyncDataUserInterests } = useDpFanStages();

	const router = useNextRouter();

	const handleClick = () => {
		const { teams, sports, size } = onSyncDataUserInterests();

		const isShouldData =
			(teams && teams.length > 0) ||
			(sports && sports.length > 0) ||
			Object.keys(size).filter((key) => key !== 'GENDER' && key !== 'BIRTHDAY').length > 0;

		router.push(isShouldData ? '/perfil-estilo' : '/quiz-estilo');
	};

	if (isLoadingUserInterests || isLoadingPersonInfo) {
		return (
			<Skeleton
				variant="rectangular"
				sx={{ mt: '24px', width: '100%', height: { xs: '192px', md: '48px' } }}
			/>
		);
	}

	return (
		<>
			<Box
				sx={{
					backgroundColor: '#FFFFFF',
					border: '1px solid #ECECEC',
					minHeight: '46px',
					display: { xs: 'none', md: 'flex' },
					justifyContent: 'space-between',
					alignItems: 'center',
					marginTop: '18px',
					paddingRight: '16px',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '21px' }}>
					<Img src="/images/dpfan/account/account-dpfan-desk.png" alt="dpfan" />
					<Typography sx={{ color: '#000000', fontSize: '16px', fontWeight: '800' }}>
						ZONA FAN:
						<Typography
							component="span"
							sx={{ color: '#000000', fontSize: '16px', fontWeight: '500' }}
						>
							Construye tu Perfil de Superaficionado
						</Typography>
					</Typography>
				</Box>
				<DpButton
					variant="text"
					disabled={isLoadingUserInterests || isLoadingPersonInfo}
					onClick={handleClick}
				>
					Ver zona fan
				</DpButton>
			</Box>
			<Divider
				sx={{ display: { xs: 'flex', md: 'none' }, marginTop: '24px', marginBottom: '24px' }}
			/>
			<ButtonBase
				sx={{
					width: '100%',
					backgroundColor: '#FFFFFF',
					display: { xs: 'flex', md: 'none' },
					flexDirection: 'column',
					gap: '6px',
				}}
				disabled={isLoadingUserInterests || isLoadingPersonInfo}
				onClick={handleClick}
			>
				<Img src="/images/dpfan/account/account-dpfan-mob.png" sx={{ width: '100%' }} alt="dpfan" />
				<Typography sx={{ color: '#000000', fontSize: '18px', fontWeight: '800' }}>
					ZONA FAN
				</Typography>
			</ButtonBase>
		</>
	);
};
